import type { ReactElement } from 'react';
import Checkbox from 'components/shared/Checkbox';
import SkeletonLine from 'components/shared/skeletons/SkeletonLine';

function PaymentInfoSkeleton(): ReactElement {
  return (
    <>
      <div className="c-form-group d-flex justify-content-between">
        <span>
          <SkeletonLine width={280} height={18} className="mt-2" />
        </span>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-12">
          <div className="c-form-group">
            <Checkbox
              id="weekly-subscription-agreement"
              disabled
              label={(
                <>
                  <SkeletonLine width={160} height={18} className="mb-4" />
                  <SkeletonLine widthp={100} height={15} />
                  <SkeletonLine widthp={100} height={15} />
                  <SkeletonLine widthp={100} height={15} />
                  <SkeletonLine widthp={100} height={15} />
                  <SkeletonLine widthp={100} height={15} />
                  <SkeletonLine widthp={100} height={15} className="mb-4" />
                  <SkeletonLine width={300} height={18} />
                </>
              )}
              aria-label="Loading subscription agreement"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentInfoSkeleton;
